import styled from "@emotion/styled";

export const Root = styled.div<{ width?: string | number; minHeight?: string }>(props => ({
    verticalAlign: "top",
    display: "inline-block",
    width: props.width,
    minHeight: props.minHeight,
}));

export const Container = styled.div({ display: "flex" });

export const Name = styled.div({
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "pre",
    minWidth: 0,
});

export const Ext = styled.div({
    whiteSpace: "pre",
});
